import { useState } from 'react';
import { apiURL } from '../../../consts/URLs';
import { REGISTER } from '../../endpointList';
import { fetchRequest, getOptions } from '../../utils';

export interface Register {
    name: string;
    email: string;
    password: string;
}

const useRegister = (token?: string | null) => {
    const [registerResponse, setRegisterResponse] = useState<any>();
    const [registerResult, setRegisterResult] = useState<any>();

    const register = (obj: Register) => {
        console.log(token);
        const url = `${apiURL}/${REGISTER}?email=${obj.email}&password=${obj.password}&name=${obj.name}`;
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(url, options, setRegisterResponse, setRegisterResult);
    };

    console.log({ registerResponse, registerResult, register });

    return { registerResponse, registerResult, register };
};
export default useRegister;
